module.exports = __webpack_public_path__ + "static/media/rom8.882d58bc.jpg";